export class ProductImage {
  constructor (image) {
    this.original = image.original
    this.small = image.small
  }
}
